<template>
  <div>
    <!-- hero desktop -->
    <div v-if="hero && desktop">
      <span v-if="soldOut" :href="formUrl" class="btn btn-cta btn-cta-span" id="btn-cta-desktop-span" @click="showSoldOutMessage">Consigue tu crédito</span>
      <a v-else :href="formUrl" class="btn btn-cta" id="btn-cta-desktop">Consigue tu crédito</a>
    </div>
    <!-- hero -->
    <div v-else-if="hero && !desktop" class="col-12 col-sm-10 offset-sm-1">
        <span v-if="soldOut" :href="formUrl" class="btn btn-cta btn-cta-span" id="btn-cta-span" @click="showSoldOutMessage">Consigue tu crédito</span>
        <a v-else :href="formUrl" class="btn btn-cta" id="btn-cta">Consigue tu crédito</a>
    </div>
    <div v-else class="col-10 offset-1 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
      <span v-if="soldOut" class="btn btn-cta btn-cta-green mt-5 mb-5" @click="showSoldOutMessage">Consigue tu crédito</span>
      <a v-else :href="formUrl" class="btn btn-cta btn-cta-green mt-5 mb-5">Consigue tu crédito</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetYourCreditButton',
  props: {
    formUrl: '',
    soldOut: {
      type: Boolean,
      default: false
    },
    soldOutMessage: {
      type: String,
      default: 'Lo sentimos, el cupo de solicitudes se ha completado. Esperanos en la próxima campaña'
    },
    hero: {
      type: Boolean,
      default: false
    },
    desktop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showSoldOutMessage: function () {
      alert(this.soldOutMessage)
    }
  }
}
</script>

<style>
.btn-cta, .btn-cta-span {
  border-radius: 39.5px;
  background-color: #6169FC;
  box-shadow: inset 0 -4px 0 0 rgba(0,0,0,0.17), 0 2px 3px 0 rgba(0,0,0,0.12);
  color: #FFFFFF;
  font-size: 1.1rem;
  font-weight: bold !important;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  text-shadow: 0 1px 1px 0 rgba(0,0,0,0.1);
  padding: 0.9em 3em 0.9em 3em;
  width: 100%;
}
#btn-cta, #btn-cta-desktop, #btn-cta-desktop-span {
  border-radius: 39.5px;
  background-color: #6169FC;
  box-shadow: inset 0 -4px 0 0 rgba(0,0,0,0.17), 0 2px 3px 0 rgba(0,0,0,0.12);
  color: #FFFFFF;
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  text-shadow: 0 1px 1px 0 rgba(0,0,0,0.1);
  padding: 0.9em 3em 0.9em 3em;
  width: 100%;
}
@media (max-width: 768px) {
  #btn-cta {
    width: 100%;
    font-size: 1.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/GetYourCreditButton.vue